import { motion } from "framer-motion";
import { Leaf, Users, Scale } from "lucide-react";

const PILLARS = [
    {
        icon: Leaf,
        title: "Environmental Responsibility",
        body: "We support sustainable supply chain vision through efficient routing, responsible sourcing awareness and practical logistics coordination.",
    },
    {
        icon: Users,
        title: "Social Responsibility",
        body: "We build relationships that respect communities, consumers, halal-sensitive sourcing expectations and long-term partner development.",
    },
    {
        icon: Scale,
        title: "Corporate Governance",
        body: "We prioritize ethical trade, documentation awareness, compliance support and transparent commercial coordination.",
    },
];

export const ESG = () => {
    return (
        <section
            id="esg"
            data-testid="esg-section"
            className="relative bg-[#0B0807]/82 backdrop-blur-md py-24 sm:py-32 lg:py-40 px-4 sm:px-8 lg:px-12 border-t border-white/5"
        >
            <div className="flex items-center gap-3 font-mono-text text-[10px] sm:text-xs uppercase tracking-[0.3em] text-zinc-500 mb-6">
                <span className="h-px w-10 bg-[#D69331]" />
                <span>09 / ESG & Sustainability</span>
            </div>

            <motion.h2
                initial={{ y: 60, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8 }}
                className="font-display uppercase font-bold leading-[0.9] tracking-tight text-white text-4xl sm:text-6xl lg:text-7xl max-w-5xl"
            >
                Responsible growth.{" "}
                <span className="text-zinc-600">Ethical trade.</span>{" "}
                <span className="text-[#D69331]">Sustainable impact.</span>
            </motion.h2>

            <p className="mt-8 font-mono-text text-sm sm:text-base text-zinc-400 leading-relaxed max-w-3xl">
                At DUHA Global Trading, sustainability is not a separate
                initiative. It is an integral part of how we operate, grow and
                build international partnerships.
            </p>

            <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-zinc-900 border border-zinc-900">
                {PILLARS.map((p, i) => {
                    const Icon = p.icon;
                    return (
                        <motion.div
                            key={p.title}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-30px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="bg-[#0a0a0a] p-8 sm:p-10 lg:p-12 min-h-[320px] flex flex-col group hover:bg-[#0f0f0f] transition-colors"
                        >
                            <div className="flex items-center justify-between">
                                <Icon
                                    size={28}
                                    strokeWidth={1.5}
                                    className="text-[#D69331]"
                                />
                                <span className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-zinc-600">
                                    Pillar 0{i + 1}
                                </span>
                            </div>
                            <h3 className="mt-8 font-display uppercase text-2xl sm:text-3xl font-semibold leading-tight text-white">
                                {p.title}
                            </h3>
                            <p className="mt-5 font-mono-text text-sm text-zinc-400 leading-relaxed mt-auto">
                                {p.body}
                            </p>
                        </motion.div>
                    );
                })}
            </div>
        </section>
    );
};
